module.exports = __webpack_public_path__ + "img/webhook_icon.308ff893.svg";